import TopSideArrowIcon from "components/icons/TopSideArrowIcon";
import React, { useState } from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { AppRoutes } from "utils/routes";
import TimeLineBar from "./TimeLineBar";
import { useModal } from "contexts/modal";
import "./scss/TimeLineDetails.scss";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useSelector } from "react-redux";

const TimeLineDetails = () => {
  const path = useLocation();
  const params = useParams();
  const navigate = useNavigate();
  const {
    urlDtails,
    setIsmenuOpen,
    isExpanded,
    seturl,
    setisExpanded,
    url,
    timelinBarBagroundColor,
  } = useModal();
  const { activeEventCardData } = useSelector((store: any) => store.keyEvents);
  const [isAnimated, setisAnimated] = useState("");
  const isKeyEventDetailsPage =
    path?.pathname === AppRoutes.events(params?.event);

  const isLandingPage = window.location.pathname === "/";

  const handleLeftSideButton = () => {
    if (url === 0) {
      setIsmenuOpen(false);
      navigate("/");
    } else {
      seturl(url - 1);
      setIsmenuOpen(true);

      navigate(urlDtails[url - 1]);
    }
  };
  const handleRightSideButton = () => {
    if (url === urlDtails.length - 1) return;
    setIsmenuOpen(true);
    if(url+1 === 2){
    }
    seturl(url + 1);
    if(url+1 === 2) {
      navigate(AppRoutes.events(activeEventCardData.year_title))
      
    }
    else {
      navigate(urlDtails[url + 1]);
    }
 
  };

  return (
    <>
      <div
        className={`time-line-details ${
          isExpanded ? "expanded-animated-view" : ""
        } ${isAnimated === "true" ? "collapsible-animated-view" : ""}`}
        style={
          isKeyEventDetailsPage
            ? { bottom: "-48px", background: `var(${timelinBarBagroundColor})` }
            : { background: `var(${timelinBarBagroundColor})` }
        }
      >
        {isExpanded ? (
          <div
            className="top-side-card"
            onClick={() => {
              setisAnimated("true");
              setisExpanded(false);
            }}
          >
            <TopSideArrowIcon />
          </div>
        ) : url !== 0 ? (
          <div
            className="top-side-card rotate-icon"
            onClick={() => {
              setisExpanded(false);
            }}
          >
            {url !== 0 && <TopSideArrowIcon />}
          </div>
        ) : (
          ""
        )}
        {url !== 0 ? (
          <div
            className={`top-side-card ${!isExpanded ? "" : "rotate-icon"}`}
            onClick={() => {
              if (isLandingPage) return;
              setisAnimated("true");
              setisExpanded(!isExpanded);
            }}
          >
            <TopSideArrowIcon />
          </div>
        ) : (
          ""
        )}
        {url !== 0 ? (
          <div
            className="arrow-card left-side-card"
            onClick={handleLeftSideButton}
          >
            <ArrowBackIosIcon  className="arrow-left" style={{ color: "white" }} />{" "}
            <span className="left-arrow-timelinbar"> Prev</span>
          </div>
        ) : (
          ""
        )}

        <div className="time-line-events-bars">
          <TimeLineBar isExpanded={isExpanded} />
        </div>
        <div
          className="arrow-card right-side-card"
          onClick={handleRightSideButton}
        >
          <span className="right-arrow-timelinbar"> Next </span>{" "}
          <ArrowForwardIosIcon style={{ color: "white" }} />
        </div>
      </div>
    </>
  );
};

export default TimeLineDetails;
